import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import AgentCredentials from '@/features/agent-credentials';
import { useBuilder } from '../store/provider';
const CredentialsView = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "credentials"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    state
  } = useBuilder();
  if (!state.session) {
    return null;
  }
  const t1 = state.session.agentId;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== state.session.agentId || $[6] !== t2 || $[7] !== t3) {
    t4 = <div className="max-w-[800px] mx-auto px-6 py-8 sm:px-10"><AgentCredentials agentId={t1} title={t2} subtitle={t3} /></div>;
    $[5] = state.session.agentId;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default CredentialsView;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.agentSubtitle;
}